import { Tag, Tooltip } from "antd";

import { type Order } from "@fitness-app/data-models/entities/Order";
import { getHumanPrice } from "@fitness-app/utils/src/products/getHumanPrice";

export const CrossSellInfo = ({ crossSell }: { crossSell: Order["crossSell"] }): React.ReactElement | null => {
  if (!crossSell?.length) {
    return null;
  }

  return (
    <Tooltip
      title={
        <ul>
          {crossSell.map((product) => (
            <li key={product.priceId}>
              {product.productName || product.productId} - {getHumanPrice(product.priceAmount, product.priceCurrency)}
            </li>
          ))}
        </ul>
      }
    >
      <Tag color="blue">+{crossSell.length}</Tag>
    </Tooltip>
  );
};
